var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"LibraryDel"}},[_c('Head'),_c('img',{attrs:{"src":_vm.imgs[_vm.id].src,"alt":""}}),_c('Foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }